<template>
  <div :class="{'article-feature': true, 'text-body': true, 'dh-psy-paragraph': true, 'dh-psy-paragraph--lead': isLead, 'dh-psy-paragraph--ingress': isIngress}">
    <p v-if="typeof extractedContent === 'string'" v-html="extractedContent"> />
      <p v-else>
        <span v-for="(text, idx) in extractedContent" :key="idx">
          <span v-if="typeof text === 'string'" v-html="text" />
          <enhanced-text v-else :value='text.value' :type='text.type'></enhanced-text>
        </span>
      </p>
  </div>
</template>

<style scoped lang="postcss">
  div.article-feature.text-body {
    padding: 0 18px;
    padding: 0 1.125rem;
    color: inherit;
  }

  .article-feature.dh-psy-paragraph > * {
    padding: 18px 0;
    float: none;
  }

  .dh-psy-paragraph--lead,
  .dh-psy-paragraph--ingress {
    font-family: NRK Etica Slab;
  }

  .dh-psy-paragraph--lead {
    font-size: calc(1em + 0.1vw);
    font-family: NRK Etica Slab;
    line-height: 1.6;

    & :global(span) {
      font-weight: bold;
      color: #14a081;
    }

    & :global(.red) {
      color: #e51c30;
    }

    @media (min-width: 450px) {
      font-size: calc(1.1em + 0.1vw);
    }

    @media (min-width: 650px) {
      font-size: calc(1.3em + 0.1vw);
    }
  }

  .dh-psy-paragraph--ingress {
    font-size: calc(1.1em + 0.1vw);

    @media (min-width: 800px) {
      font-size: calc(1.2em + 0.1vw);
    }
  }

  div.article-feature.text-body.dh-psy-paragraph--lead {
    max-width: 100% - 2em;
    padding: 0 2em;

    & > * {
      padding-top: 0;
    }
  }
</style>

<script>
import EnhancedText from './components/enhanced-text/index.vue'
export default {
  props: ['content', 'isLead', 'isIngress'],
  components: {
    EnhancedText
  },
  computed: {
    extractedContent() {
      return this.content.item.value
    }
  }
}
</script>
